export function numberToWords(num) {
  // --- Setup Lookup Tables ---

  // 0-19 are unique
  const ones = [
    "zero",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
    "ten",
    "eleven",
    "twelve",
    "thirteen",
    "fourteen",
    "fifteen",
    "sixteen",
    "seventeen",
    "eighteen",
    "nineteen",
  ];

  // 20-90 (indices 0 and 1 are empty for alignment)
  const tens = [
    "",
    "",
    "twenty",
    "thirty",
    "forty",
    "fifty",
    "sixty",
    "seventy",
    "eighty",
    "ninety",
  ];

  // The 'scales' of numbers (thousand, million, etc.)
  const scales = [
    "",
    "thousand",
    "million",
    "billion",
    "trillion",
    "quadrillion",
    "quintillion",
  ];

  // --- Helper Function (Converts 0-999) ---

  /**
   * Converts a 3-digit number (0-999) into words.
   * @param {number} num - The number to convert (must be 0-999).
   * @returns {string} The word representation.
   */
  function convertUpToThousand(num) {
    let word = "";

    // 1. Handle hundreds place
    if (num >= 100) {
      word += ones[Math.floor(num / 100)] + " hundred";
      num %= 100; // Get remainder
      if (num > 0) {
        word += " "; // Add space if there are tens/ones
      }
    }

    // 2. Handle tens and ones place
    if (num > 0) {
      if (num < 20) {
        // Use the 'ones' array for 0-19
        word += ones[num];
      } else {
        // Use the 'tens' array for 20-99
        word += tens[Math.floor(num / 10)];
        if (num % 10 > 0) {
          // Add hyphen and the 'ones' part
          word += "-" + ones[num % 10];
        }
      }
    }
    return word;
  }

  // --- Main Function Logic ---

  // 1. Handle edge cases
  if (num === 0) return "zero";

  if (typeof num !== "number" || !isFinite(num)) {
    return "Not a valid number";
  }

  // 2. Handle negative numbers
  if (num < 0) {
    return "negative " + numberToWords(Math.abs(num));
  }

  // 3. Handle non-integers (remove decimal part)
  num = Math.floor(num);

  let wordParts = [];
  let scaleIndex = 0;

  // 4. Process the number in "chunks" of 1000
  while (num > 0) {
    // Get the last 3 digits
    const chunk = num % 1000;

    if (chunk > 0) {
      // Convert the 3-digit chunk to words
      const chunkWords = convertUpToThousand(chunk);

      // Get the appropriate scale word (e.g., "thousand", "million")
      const scaleWord = scales[scaleIndex];

      // Combine chunk words and scale word
      // (scaleWord is empty for the first chunk)
      const part = chunkWords + (scaleWord ? " " + scaleWord : "");

      // Add this part to the *beginning* of the array
      wordParts.unshift(part);
    }

    // Move to the next 3-digit chunk
    num = Math.floor(num / 1000);
    scaleIndex++;

    // Safety check for numbers larger than the defined scales
    if (scaleIndex >= scales.length && num > 0) {
      return "Number is too large to convert";
    }
  }

  // 5. Join all parts with a space
  return wordParts.join(" ");
}
